import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import {getCounts, getUserInfo, informations} from "@/api";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    blogInfo:{
      webSite:{}
    },
    loginFlag:false,
    registerFlag:false,
    searchFlag:false,
    emailFlag:false,
    forgetFlag:false,
    user:{},
    counts:{
      article : 0,
      category : 0,
      tag : 0
    },
    is_drawer:false,
    token: null,
  },
  mutations: {
    setUser(state,user){
      if(user.token){
        state.token = user.token;
      }

      state.user = user;
    },
    closeModel(state) {
      state.registerFlag = false;
      state.loginFlag = false;
      state.searchFlag = false;
      state.emailFlag = false;
    },
    setBlogInfo(state,res){
      state.blogInfo.webSite = res;
    },
    setCounts(state,res){
      state.counts.article = res.article;
      state.counts.tag = res.tag;
      state.counts.category = res.category;
    },
    logout(state){
      state.token = null;
      state.user = {};
    }
  },
  actions: {
    getBlogInfo(state){
      //配置
      informations().then(res=>{
        state.commit('setBlogInfo',res.data);
      });
      //文章，分类，标签数量
      getCounts().then(res=>{
        state.commit('setCounts',res.data);
      })
    },
    async getUserInfo(state){
      const res = await getUserInfo();
      state.commit('setUser', res.data);
      return res.data;
    }
  },
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
});
